/**
 * Cor do badge de prazo de produção a partir do texto exibido ("1 dia", "3 dias"...).
 * Até 1 dia: cinza; 2 a 3 dias: amarelo; a partir de 4 dias: vermelho.
 */
export function getPrazoProducaoColorClass(prazo: string): string {
  switch (prazo) {
    case "0 dia":
      return "bg-gray-300 text-black";
    case "1 dia":
      return "bg-gray-300 text-black";
    case "2 dias":
      return "bg-yellow-500 text-white";
    case "3 dias":
      return "bg-yellow-500 text-white";
    case "4 dias":
      return "bg-red-500 text-white";
    case "5 dias":
      return "bg-red-500 text-white";
    case "6 dias":
      return "bg-red-500 text-white";

    default:
      return "bg-red-500 text-white";
  }
}
